import {initializeFileHandler, removeFile} from './shared/uploader_utils';

let allVehicleIncidentImages = []

window.reloadVehicleIncidentFileUploader = () => {
  // Target the container where Cocoon inserts nested fields
  const container = document.querySelector('#vehicle-incidents-images-container');

  if (!container) {
    return;
  }

  initializeVehicleIncidentFileHandler('vehicle-incidents-images', allVehicleIncidentImages);
  setTimeout(updateRequiredRadios, 500); // short delay to allow DOM load
  bindIncidentFileRemoveEvent(container, allVehicleIncidentImages);
  toggleAccidentFields();
  // toggleAtFaultFields();
  // toggleExchangeInfoFields();

  // Initialize MutationObserver
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const uploadContainer = node.querySelector('.upload-form.file-upload-area');
          const fileField = node.querySelector('input[type="file"]');
          const previewsContainer = document.querySelector('[data-preview=vehicle-incidents-images-preview]');

          if (uploadContainer && fileField && previewsContainer) {
            // Small delay to ensure DOM is ready
            setTimeout(function() {
              initializeFileHandler(uploadContainer, fileField, previewsContainer);
            }, 100);
          }
        }
      });
    });
  });

  // Start observing the container for child additions
  observer.observe(container, { childList: true, subtree: true });

  $(document).on("change", 'input[name="vehicle_incident[was_accident]"]', toggleAccidentFields);
  // $(document).on("change", 'input[name="vehicle_incident[at_fault]"]', toggleAtFaultFields);
  // $(document).on("change", 'input[name="vehicle_incident[exchanged_insurance_info]"]', toggleExchangeInfoFields);
}

function initializeVehicleIncidentFileHandler(attachmentName, selectionList) {
  const container = document.querySelector(`#${attachmentName}-container`);
  // Initialize handlers for existing permit file fields
  const permitFileForms = container.querySelectorAll('.nested-fields.form-card');
  
  permitFileForms.forEach(function(form) {
    const uploadContainer = form.querySelector('.upload-form.file-upload-area');
    const fileField = form.querySelector('input[type="file"]');
    const previewsContainer = container.querySelector(`[data-preview=${attachmentName}-preview]`);
    
    if (uploadContainer && fileField && previewsContainer) {
      initializeFileHandler(uploadContainer, fileField, previewsContainer, selectionList);
    }
  });
}

function bindIncidentFileRemoveEvent(container, selectionList) {
  container.querySelectorAll('.file-preview').forEach(filePreview => {
    filePreview.addEventListener('click', (e) => removeFile(e, selectionList));
  })
}

function updateRequiredRadios() {
  $('div[data-radio-group]').each(function() {
    if($(this).find('.requiredField').is(':checked')) {
      $(this).find('.requiredField').removeClass('requiredField');
    }
  });
}

function resetHiddenFields(container) {
  // Uncheck radios/checkboxes without wiping their value
  container.find('input[type=radio]').prop('checked', false);

  // Clear text and file inputs
  container.find('input[type=text], input[type=file]').val('');
  updateRequiredFields(container);
}

function updateRequiredFields(container){
  const inputFields = container.find('input[type=radio], input[type=text], input[type=file].fileUpload');
  const fileDropzone = container.find('div.upload-form.file-upload-area');
  const errorElement = container.find('div.error-message.text-danger');

  if(container.hasClass('d-none')) {
    inputFields.removeClass('requiredField error-field is-invalid');
    fileDropzone.removeClass('error-field is-invalid');
    errorElement.remove();
  } else {
    inputFields.addClass('requiredField');
  }
}

function toggleAccidentFields() {
  const wasAccident = $('input[name="vehicle_incident[was_accident]"]:checked').val();

  if (wasAccident === "true") {
    $("#at-fault-field").removeClass("d-none");
    $("#extra-incident-uploads").removeClass("d-none")
    updateRequiredFields($("#at-fault-field"));
    updateRequiredFields($("#extra-incident-uploads"));
  } else {
    $("#at-fault-field, #extra-incident-uploads")
      .addClass("d-none")
      .each(function () { resetHiddenFields($(this)); });
  }
}

// function toggleAccidentFields() {
//   const wasAccident = $('input[name="vehicle_incident[was_accident]"]:checked').val();

//   if (wasAccident === "true") {
//     $("#at-fault-field").removeClass("d-none");
//     updateRequiredFields($("#at-fault-field"));
//   } else {
//     $("#at-fault-field, #exchange-info-field, #offender-input-fields, #extra-incident-uploads, #insurance-provider-field")
//       .addClass("d-none")
//       .each(function () { resetHiddenFields($(this)); });
//   }
// }

// function toggleAtFaultFields() {
//   const atFault = $('input[name="vehicle_incident[at_fault]"]:checked').val();

//   if (atFault === "false") {
//     $("#exchange-info-field").removeClass("d-none");
//     updateRequiredFields($("#exchange-info-field"));
//   } else {
//     $("#exchange-info-field, #offender-input-fields, #extra-incident-uploads, #insurance-provider-field")
//       .addClass("d-none")
//       .each(function () { resetHiddenFields($(this)); });
//   }
// }

// function toggleExchangeInfoFields() {
//   const exchangedInfo = $('input[name="vehicle_incident[exchanged_insurance_info]"]:checked').val();

//   if (exchangedInfo === "true") {
//     $("#offender-input-fields, #extra-incident-uploads, #insurance-provider-field").removeClass("d-none");
//     updateRequiredFields($("#offender-input-fields"));
//     updateRequiredFields($("#extra-incident-uploads"));
//     updateRequiredFields($("#insurance-provider-field"));
//   } else {
//     $("#offender-input-fields, #extra-incident-uploads")
//       .addClass("d-none")
//       .each(function () { resetHiddenFields($(this)); });
//   }
// }

document.addEventListener('turbolinks:load', function() {
  reloadVehicleIncidentFileUploader();
});
